import React from 'react';

export function Input({ field, value, handleChange, error, touched }) {
  return (
    <>
      <label
        htmlFor={field.name}
        className="block text-sm font-medium text-gray-500"
      >
        {field.label}
      </label>
      <input
        name={field.name}
        id={field.name}
        type={field.type}
        value={value}
        onChange={handleChange}
        className="mt-1 focus:ring-sky-500 focus:border-sky-500 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 border-slate-300 border outline-0"
      />
      {error && touched && <div className="text-xs text-red-500">{error}</div>}
    </>
  );
}

export function Textarea({ field, value, handleChange, error, touched }) {
  return (
    <>
      <label
        htmlFor={field.name}
        className="block text-sm font-medium text-gray-500"
      >
        {field.label}
      </label>
      <textarea
        name={field.name}
        id={field.name}
        rows={3}
        className="shadow-sm focus:ring-sky-500 focus:border-sky-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md p-3 outline-0"
        placeholder=""
        onChange={handleChange}
        defaultValue={value}
      />
      {error && touched && <div className="text-xs text-red-500">{error}</div>}
    </>
  );
}

export function Select({ optionList, handleOnChange, selectedValue }) {
  return (
    <select
      onChange={(e) => handleOnChange(e)}
      id="quantity"
      name="quantity"
      autoComplete="quantity"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm text-gray-600"
      defaultValue={selectedValue}
    >
      {optionList.map((i) => (
        <option key={i.name} value={i.value}>
          {i.name}
        </option>
      ))}
    </select>
  );
}
